module.exports = __webpack_public_path__ + "img/72_19.930ac8e3.png";